import { Component, EventEmitter, Inject, OnInit, OnDestroy, Output } from '@angular/core';
import { ApplicationFacade, DeviceNotificationService } from '@ridango/components';
import { OnboardingLoginType } from './enums/onboarding-login.enum';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { OnboardingService } from '@ridango/core/lib/services';
import { OnboardingType } from '../../../enums';
import { take } from 'rxjs/operators';
import Env from '@ridango/core/env';
import { Capacitor } from '@capacitor/core';
import { RequestPermissionService } from '@ridango/components/lib/firebase/request-permission.service';
import { BaseComponent } from '@ridango/core';
import { StatusBarService } from '@ridango/core/lib/services/status-bar.service';
import { Observable } from 'rxjs';
import { ScreenOrientationService } from '@ridango/core/lib/services/screenOrientation.service';

@Component({
    selector: 'rwidget-onboarding-login',
    templateUrl: './onboarding-login.component.html',
    styleUrls: ['./onboarding-login.component.scss']
})
export class OnboardingLoginComponent extends BaseComponent implements OnInit, OnDestroy {
    assetsPath$ = this.applicationFacade.assetsPath$;
    onboardingLoginType = OnboardingLoginType;
    onboardingType = OnboardingType;
    onboardingLoginFeature = this.env.ONBOARDING.LOGIN;
    isContrast = 'default';
    previousContrast = 'default';
    onlyPortraitMode$: Observable<boolean> = this.screenOrientationService.onlyPortraitMode$;

    @Output() themeToggle: EventEmitter<void> = new EventEmitter();

    accessibilityToggle = false;

    constructor(
        @Inject('ENV') public env: Env,
        private applicationFacade: ApplicationFacade,
        private router: Router,
        private translate: TranslateService,
        private onboardingService: OnboardingService,
        private pushNotification: DeviceNotificationService,
        private statusBarColor: StatusBarService,
        private requestPermissionService: RequestPermissionService,
        private screenOrientationService: ScreenOrientationService
    ) {
        super();
    }

    ngOnInit(): void {
        this.isHighContrast();
        this.setStatusBarColor();
        this.requestPermission();
    }

    setStatusBarColor() {
        if (!this.env.STATUS_BAR) {
            return;
        }

        if (this.env.STATUS_BAR.COLOR_LOGIN_FLOW) {
            this.statusBarColor.setStatusColor(this.env.STATUS_BAR.COLOR_LOGIN_FLOW);
        }

        if (this.env.STATUS_BAR && this.env.STATUS_BAR.HIDE_LOGIN_FLOW_BAR) {
            this.statusBarColor.hideStatusBar();
        }
    }

    toggleContrast() {
        this.themeToggle.emit();
        this.isHighContrast();
    }

    navigateToFlow(path: string, type: OnboardingType = this.onboardingType.LOGIN_PAGE) {
        this.onboardingService.onboardingStatus = this.env.ONBOARDING.LOGIN.REQUIRE_LOGIN
            ? type
            : this.onboardingType.COMPLETED;
        this.router.navigate([this.translate.currentLang, path]);
    }

    isHighContrast() {
        this.applicationFacade.highContrast$.pipe(take(1)).subscribe((isContrast) => {
            this.isContrast = !isContrast ? 'default' : 'high-contrast';
        });
    }

    requestPermission() {
        if (Capacitor.isNativePlatform() && this.env.NOTIFICATION_PAGE_USER) {
            this.pushNotification.isFirstInit = true;
            this.requestPermissionService.requestPermissionNotification();
        }
    }

    async skipLogin() {
        // this will only be used by GL and Sörmland for now, and as agreed with Maja, they will redirect to JP.
        this.onboardingService.onboardingStatus = this.onboardingType.COMPLETED;
        await this.router.navigate([
            this.translate.currentLang,
            ...(this.env.DEFAULT_REDIRECT_AFTER_LOGIN ?? ['journey-planner'])
        ]);
    }

    openContrastSettings() {
        this.previousContrast = this.isContrast;
        this.accessibilityToggle = true;
    }

    cancelContrastChanges() {
        if (this.previousContrast !== this.isContrast) {
            this.toggleContrast();
        }
        this.accessibilityToggle = false;
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }
}
